<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Sku List
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="_headers"
      :items="list"
      :loading="listLoader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  outlined
                  v-model="client"
                  :items="clients"
                  dense
                  chips
                  small-chips
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  @focus="fetchClientList"
                  @change="fetchTagList"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  outlined
                  v-model="category"
                  :items="categories"
                  dense
                  chips
                  small-chips
                  item-text="category_code"
                  item-value="category_code"
                  label="Select Category"
                  :loading="categoryLoader"
                  @focus="fetchCategoryList"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Product Name"
                  v-model="title"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-text-field outlined v-model="sku" label="SKU"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  outlined
                  v-model="bundle"
                  :items="bundles"
                  dense
                  chips
                  small-chips
                  item-text="text"
                  item-value="value"
                  label="Bundle"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  outlined
                  v-model="map"
                  :items="mapped"
                  dense
                  chips
                  small-chips
                  item-text="text"
                  item-value="value"
                  label="Mapped"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="userCategory.user_category === 3 && client"
              >
                <v-autocomplete
                  outlined
                  v-model="tags"
                  :items="tagesList"
                  dense
                  chips
                  small-chips
                  item-text="tag_name"
                  item-value="tag_name"
                  label="Tags"
                  item-key="tag_name"
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" v-if="userCategory.user_category === 1">
                <v-autocomplete
                  outlined
                  v-model="tags"
                  :items="tagesList"
                  dense
                  chips
                  small-chips
                  item-text="tag_name"
                  item-value="tag_name"
                  item-key="tag_name"
                  label="Tags"
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  outlined
                  v-model="hscode"
                  :items="mapped"
                  dense
                  chips
                  small-chips
                  item-text="text"
                  item-value="value"
                  label="HS Code"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                :sm="userCategory.user_category == 3 ? '12' : '6'"
                class="mt-0"
              >
                <v-btn
                  color="green"
                  dark
                  style="float: right"
                  class="ml-3 success v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="listPage"
                  v-if="userCategory.user_category === 3"
                >
                  List
                </v-btn>

                <v-btn
                  @click="syncScrren()"
                  color="primary"
                  :loading="syncButton"
                  style="float: right"
                  v-if="
                    userCategory.user_category === 3 &&
                    checkPermission('app_ecom_vendors:fulfillment_sku_sync')
                  "
                  class="ml-3 v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  >Sync</v-btn
                >
                <v-btn
                  v-if="userCategory.user_category === 3"
                  color="primary"
                  class="ml-3 v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="dialog = true"
                  style="float: right"
                  >Upload</v-btn
                >
                <v-btn
                  color="info"
                  class="ml-3 v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="download"
                  style="float: right"
                  :loading="downloader"
                  >Download</v-btn
                >
                <v-btn
                  color="white v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  class="ml-4"
                  @click="clearAll"
                  style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </v-row>
            <v-divider class="mt-2 mb-2"></v-divider>
          </v-form>
        </template>
      </template>
      <template v-slot:[`item.dimensions`]="{ item }">
        <label>
          {{ item.weight }} kg | <strong>W:</strong> {{ item.width }} |
          <strong>H:</strong> {{ item.height }} | <strong>L:</strong>
          {{ item.length }}
        </label>
      </template>

      <template v-slot:[`item.unit_price`]="{ item }">{{
        changeFormat(item.unit_price)
      }}</template>
      <template v-slot:[`item.created_at`]="{ item }">{{
        item.created_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
      }}</template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      max-width="550px"
      close-delay="ma-5"
      @keydown.esc="dialog = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Upload SKU Data</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <div class="text-center py-0 mt-2">
              <v-row no-gutters>
                <v-col md="12" v-if="userCategory.user_category === 3">
                  <v-autocomplete
                    v-model="selectedClient"
                    :items="clients"
                    :loading="clientLoader"
                    hide-no-data
                    hide-details
                    item-text="name"
                    item-value="id"
                    label="Select Client"
                    placeholder="Start typing to Search"
                    class="pb-2 pt-0 text-center required"
                    return-object
                    @focus="fetchClientList"
                  ></v-autocomplete>
                </v-col>
                <v-col md="12" class="custom">
                  <v-file-input
                    v-model="file"
                    counter
                    show-size
                    accept=".xlsx"
                    label="Select your product file"
                    :rules="[(v) => !!v || 'Please select Product File']"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <v-row class="text-left">
                <v-col>
                  <v-btn
                    color="info"
                    class="mr-2 mt-3"
                    :loading="downloaderTemp"
                    @click="downloadTemplate()"
                    >Download template</v-btn
                  >
                  <v-btn
                    color="primary"
                    dark
                    class="mt-3"
                    :loading="fileLoader"
                    @click="upload"
                  >
                    Upload
                  </v-btn>

                  <v-btn
                    class="mt-3 ml-3"
                    @click="
                      (selectedClient = null), (file = null), (dialog = false)
                    "
                  >
                    Cancel
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userCategory"]),
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "client_name" && i.value !== "mapped_with_client"
          : true;
      });
    },
  },
  data: () => ({
    syncButton: false,
    bundles: [
      {
        text: "True",
        value: "True",
      },
      {
        text: "False",
        value: "False",
      },
    ],
    mapped: [
      {
        text: "Yes",
        value: "yes",
      },
      {
        text: "No",
        value: "no",
      },
    ],
    map: "",
    hscode: "",
    title: "",
    bundle: "",
    listloader: false,
    headers: [
      {
        text: "Client",
        value: "client_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "ASN / Product / SKU",
        value: "product_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Product Name",
        value: "name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Type",
        value: "type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Tags",
        value: "tags",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Brand",
        value: "brand",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Category",
        value: "category_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Selling Price",
        value: "unit_price",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Dimensions",
        value: "dimensions",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "HS Code",
        value: "hs_code",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Mapped with client",
        value: "mapped_with_client",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Created At",
        value: "created_at",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
    ],
    carriers: [],
    sku: null,
    client: null,
    list: [],
    listLoader: false,
    filtersArr: {},
    clients: [],
    total: 0,
    options: {},
    categories: [],
    categoryLoader: false,
    category: "",
    downloader: false,
    dialog: false,
    file: null,
    selectedClient: "",
    fileLoader: false,
    tagesList: [],
    tags: [],
    clientLoader: false,
    downloaderTemp: false,
  }),

  created() {
    this.fetchClientList();
    this.fetchCategoryList();
    this.fetchTagList();
  },
  watch: {
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getSkuList",
      "fetchClient",
      "getomsCategoryList",
      "downloadSkuList",
      "uploadSku",
      "syncSKuList",
      "downloadSkuTemplate",
      "getTagsList",
    ]),
    download() {
      this.downloader = true;
      this.allFilters();
      this.downloadSkuList({
        ...this.filtersArr,
      }).then((res) => {
        this.fileDownload(res);
        this.downloader = false;
      });
    },
    clearAll() {
      (this.sku = null), (this.client = null), (this.filtersArr = {});
      this.status = null;
      this.category = null;
      this.map = null;
      this.bundle = null;
      this.title = null;
      this.tags = [];
      this.list = [];
      this.hscode = null;
      this.fetchList();
    },
    fetchTagList() {
      if (this.userCategory.user_category == 1) {
        this.getTagsList(this.$store.getters.user.id)
          .then((tags) => {
            this.tagesList = tags.data;
          })
          .catch(() => {});
      } else if (this.userCategory.user_category == 3 && this.client) {
        this.getTagsList(this.client)
          .then((tags) => {
            this.tagesList = tags.data;
          })
          .catch(() => {});
      }
    },
    fetchCategoryList() {
      if (this.categories.length == 0)
        this.getomsCategoryList()
          .then((res) => {
            this.categoryLoader = false;
            this.categories = res.data;
          })
          .catch(() => {
            this.categoryLoader = false;
          });
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "fulfillment,fulfillment_wid_last_mile",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    allFilters() {
      var tagsString = [];
      if (this.tags.length > 0) {
        tagsString = this.tags.join(",");
      } else {
        tagsString = this.tags;
      }
      this.clientsLoader = true;
      let obj = {
        client_id: this.client,
        sku: this.sku,
        bundle: this.bundle,
        mapped: this.map,
        category: this.category,
        tags: tagsString,
        title: this.title,
        hs_code: this.hscode,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    listPage() {
      this.$router.push({
        name: "skuStatusList",
        params: {
          type: "sku_mapping",
        },
      });
    },
    listPageMap() {
      this.$router.push({
        name: "skuMappingStatusList",
        params: {
          type: "sku_mapping",
        },
      });
    },

    downloadTemplate() {
      this.downloaderTemp = true;
      this.downloadSkuTemplate()
        .then((res) => {
          this.fileDownload(res);
          this.downloaderTemp = false;
        })
        .catch(() => {
          this.downloaderTemp = false;
        });
    },
    searchAll() {
      this.options.page = 1;
      this.list = [];
      this.allFilters();
      this.getSkuList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    fetchList() {
      this.list = [];
      this.listLoader = true;
      this.getSkuList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);
      if (this.userCategory.user_category === 3) {
        payload.append("client_id", this.selectedClient.id);
      }
      this.uploadSku(payload)
        .then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.$refs.form.reset();
          this.dialog = false;
          this.fileLoader = false;
        })
        .catch(() => {
          this.dialog = false;
          this.$refs.form.reset();
          this.fileLoader = false;
        });
    },
    syncScrren() {
      this.syncButton = true;
      this.syncSKuList().then((res) => {
        this.syncButton = false;
        this.snackBar({
          color: "success",
          message: res.data.message,
        });
        this.fetchList();
      });
    },
  },
};
</script>
